import React, { useContext } from "react";
import { AppContext } from "../../App";
import { col } from "framer-motion/m";

export default function KeepInTouch({ title, titleStyle, leftSection }) {
  const { colors } = useContext(AppContext);

  const styles = {
    container: leftSection,
    title: titleStyle,
  };

  const contentData = [
    {
      title: "",
      description:
        "מאז סיימתם את שנות לימודיכם בישיבה עבר זמן. אתם עובדים, לומדים באוניברסיטה או לומדים תורה במקום אחר. אולי הקמתם כבר משפחה או שאתם עומדים להתחתן. כך או כך אנחנו מקווים שהישיבה הייתה ותישאר מקום חם לכולכם. הקשר עם הבוגרים חשוב לנו מאוד. אחראי תחום בוגרים הוא הרב מנחם ויצמן, ואפשר לפנות אליו בכל ענין שקשור לבוגרי הישיבה, בטלפון: 052-7906438 או במייל: bogrim@yesmalot.co.il.",
    },
    {
      title: "קבוצת וואטסאפ מחזורית",
      description:
        "אנחנו משתדלים לשמור על קשר עם השיעור, ולא רק עם יחידים. לכל מחזור יש קבוצת וואטסאפ, שדרכה אנו שולחים לבוגרים עדכונים, מיזמים לבוגרים ועוד. לקבלת קישור לקבוצה השיעורים ניתן לפנות לרב מנחם.",
    },
    {
      title: "קו פתוח",
      description:
        "זקוק ל'ליווי' או להתייעצות? נמצא בצומת בחיים ורוצה לשתף? ניתן לפנות לראש הישיבה ולרבני הישיבה, והם ישמחו להקשיב ולענות. אפשר לפנות ישירות לרבנים או לתאם דרך הרב מנחם.   אשתך רוצה להתייעץ? מוזמנת לפנות לרבנית אסתר ויצמן בטלפון – 050-5420742.",
    },

    {
      title: "אתר הישיבה",
      description:
        "אתר הישיבה מספק מידע על פעילות הישיבה, כולל שיעורים מוקלטים, מאמרים תורניים ועדכונים על אירועים וימי עיון. ניתן ליצור קשר עם רבני הישיבה, להירשם לשיעורים חיים ולהתעדכן בפעילויות הבוגרים. האתר כולל גם ארכיון שיעורים וספריית תכנים ללימוד מכל מקום ובכל זמן. לפניות, ניתן ליצור קשר דרך האתר או המזכירות.",
    },

    {
      title: "קבוצות וואטסאפ - תורת ישיבת מעלות ועדכונים",
      description: `
        הישיבה מפעילה שתי קבוצות וואטסאפ מרכזיות:
        
        1. **קבוצת עדכונים** – מיועדת להעברת מידע חשוב על פעילויות הישיבה, אירועים קרובים, שבתות בוגרים, שיעורים חיים ושינויים בלוח הזמנים. בקבוצה זו תקבלו עדכונים ישירים מהנהלת הישיבה.
        
        2. **קבוצת תורת הישיבה** – מיועדת לשיתוף תכנים תורניים קצרים מתוך שיעורי הישיבה. בקבוצה מתפרסמים חידושים, קטעי שיעורים, קישורים להקלטות ורעיונות מעמיקים ממורשת הישיבה. ההצטרפות מומלצת לכל מי שרוצה להמשיך וללמוד מתורת הישיבה גם לאחר סיום הלימודים.
      `,
    },
    {
      title: "דירת בוגרים",
      description: `
        הישיבה מציעה דירה מיוחדת לבוגרים הרוצים לבוא וללמוד בישיבה.  
        הדירה ממוקמת בפנימיות הישיבה, משופצת ומאובזרת במיוחד, וזמינה עבור הבוגרים ומשפחתם המעוניינים להתארח בה בזמני הלימוד של הישיבה (לא בבין הזמנים).  
        האירוח ניתן ללא תשלום.
    
        בוגרים המעוניינים להגיע מוזמנים לפנות לעוזר ראש הישיבה במייל: malot@yesmalot.co.il.
      `,
    },

    {
      title: "מעלון - עלון הישיבה לבוגרים",
      description: `
        עלון הישיבה "מעלון" נשלח מדי שבוע למייל ולוואטסאפ של הבוגרים, ומכיל דברי תורה, חידושי לימוד, ועדכונים מהנעשה בישיבה.  
        בעלון ניתן למצוא תובנות משיעורי הרבנים, מאמרים קצרים, וכן מידע על אירועים קרובים, שבתות בוגרים ויוזמות נוספות.  
        לקבלת העלון במייל, ניתן להירשם דרך "טופס ליצירת קשר" שבתחתית העמוד.
      `,
    },
  ];

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>{title}</h2>

      {contentData.map((e, index) => (
        <div key={index}>
          <h3>{e.title}</h3>
          <p>{e.description}</p>
        </div>
      ))}
    </div>
  );
}
